<div class="border mt-4">
    <h5>{{title}}</h5>
    <mat-grid-list cols="2" rowHeight="100px" height="400px">
        <mat-grid-tile>
            <mat-form-field appearance="fill" [formGroup]="FormFiguras">
                <mat-label>Seleccione la figura</mat-label>
                <mat-select name="figura" formControlName="figura" (selectionChange)="changeTipoFigura($event.value)">
                        <mat-option *ngFor="let fig of catFiguras" [value]="fig?.id">
                            {{fig?.attributes?.nombre}}
                        </mat-option>
                    <mat-option [value]="0">+ Nuevo Autotransporte</mat-option>
                </mat-select>

            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button
                [disabled]="(this.FormFiguras.value.figura <= 0)" (click)="deleteTipoFigura()">Eliminar</button>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button [color]="'primary'"
                [disabled]="(this.FormFiguras.invalid)" (click)="saveOrUpdateTipoFigura()">Guardar</button>
        </mat-grid-tile>
    </mat-grid-list>

    <div class="row">
        <div class="col-sm-12">
            <hr>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4">
            <mat-form-field appearance="fill" [formGroup]="FormFiguras">
                <mat-label>Nombre Figura</mat-label>
                <input matInput formControlName="nombre">
            </mat-form-field>
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="fill" [formGroup]="FormFiguras">
                <mat-label>Tipo Figura </mat-label>
                <mat-select name="tipoFigura" formControlName="tipoFigura" (selectionChange)="selectionTipoFigura($event.value)">
                    <mat-option *ngFor="let tipofigura of tipoFigurasList" [value]="tipofigura.id">
                        {{tipofigura?.attributes?.tipo}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="(FormFiguras.get('tipoFigura').invalid && FormFiguras.get('tipoFigura').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>        
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="fill" [formGroup]="FormFiguras" [matTooltipPosition]="'above'"
                matTooltip="Este atributo debe existir siempre que el operador del
                    autotransporte federal sea nacional, en caso contrario se debe
                    omitir este atributo.">
                <mat-label>RFCFigura (<a
                        href="https://portalsat.plataforma.sat.gob.mx/ConsultaRFC/">Válido</a>)<mat-icon
                        class="mat-18">info</mat-icon></mat-label>
                <input matInput formControlName="RFCFigura" (keyup)="validaInputRFC()"
                    (input)="textUppercase('RFCFigura', $event);" maxlength="13">
                    <mat-error *ngIf="(this.f['RFCFigura'].errors?.['pattern'])">
                        <strong>RFC</strong> no es válido.
                    </mat-error>
            </mat-form-field>
            <!-- <mat-error *ngIf="(this.f['RFCFigura'].errors?.['required'])">
                Campo requerido
            </mat-error> -->
            
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4">
            <mat-label>ResidenciaFiscalFigura</mat-label>
            <mat-form-field appearance="fill" [formGroup]="FormFiguras">
                <input type="text" 
                placeholder="buscar pais" 
                aria-label="Number" 
                matInput
                formControlName="residenciaFiscalFigura" 
                [matAutocomplete]="autoPais">
                <mat-autocomplete autoActiveFirstOption #autoPais="matAutocomplete" [displayWith]="displayFuncionPais"
                    (optionSelected)="changePais($event.option.value.id)">
                    <mat-option *ngFor="let pais of filteredPais | async" [value]="pais">
                        {{pais?.attributes?.idPais}} - {{ pais?.attributes?.nombre}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="fill" [formGroup]="FormFiguras" [matTooltipPosition]="'above'"
                matTooltip="Cuando se registre el atributo “RFC”, este atributo se
                debe omitir, en caso de que el operador sea extranjero este
                atributo debe contener un valor, para lo cual se debe identificar el
                país de residencia para efectos fiscales del operador, usando la
                clave del país registrada en el atributo
                Operador:ResidenciaFiscalOperador.">
                <mat-label>NumRegIdTribFigura <mat-icon class="mat-18">info</mat-icon></mat-label>
                <input matInput formControlName="numRegIdTribFigura" (keyup)="validaInputRFC()">
                <mat-error *ngIf="(FormFiguras.get('numRegIdTribFigura').invalid && FormFiguras.get('numRegIdTribFigura').touched)">
                    Campo requerido
                </mat-error>
            </mat-form-field>
           
        </div>
        <div class="col-sm-4">
            <mat-form-field appearance="fill" [formGroup]="FormFiguras">
                <mat-label>NumLicencia</mat-label>
                <input matInput formControlName="numLicencia">
            </mat-form-field>      
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12">
            <button mat-button type="button" style="background-color:none;" (click)="addAddress()">
                <span style="color:blue;">&triangledown; Añadir Domicilio</span>
            </button>
        </div>
    </div>
    <div *ngIf="showAdress" class="row">
        <div class="col-12">
            <div class="border" style="padding: 10px;">
                <h5>Domicilio</h5>
                <div class="row">
                    <div class="col-sm-4">
                        <!--Pais-->
                        <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                            <mat-label>País </mat-label>
                            <mat-select formControlName="idPais" name="idPais" (selectionChange)="SelEstados($event.value)">
                                <mat-option *ngFor="let pg of paisesGlobal" [value]="pg?.id">
                                    {{pg?.attributes?.idPais}} - {{pg?.attributes?.nombre}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="(FormDomicilio.get('idPais').invalid && FormDomicilio.get('idPais').touched)">
                                Campo requerido
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                        <!--CodigoPostal-->
                        <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                            <mat-label>Codigo Postal </mat-label>
                            <input matInput placeholder="" formControlName="cPostal" name="cPostal"
                                (keyup)="verificaCP()"
                                onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))">
                                <mat-error *ngIf="(FormDomicilio.get('cPostal').invalid)">
                                    Campo requerido
                                </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                        <!--Estado-->
                        <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                            <mat-label>Estado</mat-label>
                            <ng-container *ngIf="estados.length==0; then estadoDefault else estadoOptions">
                            </ng-container>
                            <ng-template #estadoDefault>
                                <input matInput formControlName="estado">
                            </ng-template>
                            <ng-template #estadoOptions>
                                <mat-select formControlName="idEstado" name="idEstado"
                                (selectionChange)="selMunicipios($event.value)">
                                <mat-option *ngFor="let estado of estados" [value]="estado.id">
                                    {{estado.attributes?.idEstado}} - {{estado.attributes?.nombre}}
                                </mat-option>
                            </mat-select>
                            </ng-template>

                        </mat-form-field>
                    </div>
                </div>    
                    <div class="row">
                        <div class="col-sm-4">
                            <!--Municipio-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Municipio:</mat-label>
                                <ng-container *ngIf="municipios.length==0; then muniDefault else muniOptions">
                                </ng-container>
                                <ng-template #muniDefault>
                                    <input matInput formControlName="municipio">
                                </ng-template>
                                <ng-template #muniOptions>
                                    <mat-select formControlName="idMunicipio" name="idMunicipio"
                                    (selectionChange)="selLocalidades($event.value)">
                                    <mat-option *ngFor="let municipio of municipios" [value]="municipio.id">
                                        {{municipio.attributes?.idMunicipio}} - {{municipio.attributes?.nombre}}
                                    </mat-option>
                                </mat-select>
                                </ng-template>                              
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <!--Localidad-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Localidad:</mat-label>
                                <ng-container *ngIf="localidades.length==0; then locDefault else locOptions">
                                </ng-container>
                                <ng-template #locDefault>
                                    <input matInput formControlName="localidad">
                                </ng-template>
                                <ng-template #locOptions>
                                    <mat-select formControlName="idLocalidad" name="idLocalidad" (selectionChange)="selColonias($event.value)">
                                        <mat-option *ngFor="let localidad of localidades" [value]="localidad.id">
                                            {{localidad.attributes?.idAsentamiento}} - {{localidad.attributes?.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </ng-template>  
                                
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <!--Colonia-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Colonia:</mat-label>
                                <ng-container *ngIf="colonias.length==0; then colDefault else colOptions">
                                </ng-container>
                                <ng-template #colDefault>
                                    <input matInput formControlName="colonia">
                                </ng-template>
                                <ng-template #colOptions>
                                    <mat-select formControlName="idColonia" name="idColonia">
                                        <mat-option *ngFor="let colonia of colonias" [value]="colonia?.idAsentamiento">
                                            {{colonia?.nombre}}
                                        </mat-option>
                                    </mat-select>
                                </ng-template> 
                                
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4">
                            <!--Calle-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Calle</mat-label>
                                <input matInput placeholder="" formControlName="calle" name="calle">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <!--Numero Exterior-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Numero Exterior</mat-label>
                                <input matInput placeholder="" formControlName="numExt" name="numExt">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">
                            <!--Numero Interior-->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Numero Interior</mat-label>
                                <input matInput placeholder="" formControlName="numInt" name="numInt">
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-4">
                            <!--Referencia -->
                            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                                <mat-label>Referencia</mat-label>
                                <input matInput placeholder="" formControlName="referencia" name="referencia">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-4">

                        </div>
                        <div class="col-sm-4">

                        </div>
                    </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-sm-12">
             <ng-container *ngIf="isParteTransportes"> 
                <!--Partes Transporte-->
                <hr>
                <h4>Partes Transporte</h4>
                <div class="row justify-content-start align-items-center barraGestorPagos">
                    <div class="col-sm-12 col-md-1 col-xl-1">
                        <button (click)="addTPartes()" mat-flat-button color="primary">
                            <mat-icon svgIcon="heroicons_outline:plus-sm"></mat-icon>
                        </button>
                    </div>
                    <div class="col-sm-12 col-md-1 col-xl-1">
                        <button (click)="removeTPartes()" [disabled]="removeDisabledTPartes" mat-flat-button
                            color="warn">
                            <mat-icon svgIcon="heroicons_outline:minus-sm"></mat-icon>
                        </button>
                    </div>
                </div>
                <app-partes-transporte *ngFor="let p of countContenedor" [parte]="p"
                [catalogo]="partesTransportes"></app-partes-transporte>
            </ng-container>
        </div>

    </div>